import { cn } from '@workspace/lib';
import { Icon, TextButton } from '@workspace/ui/common';

export function CardLinkButton({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className="flex items-center gap-1 group">
      <TextButton
        isDisabled={false}
        className={cn('p-0 bg-transparent !font-semibold text-primary hover:!no-underline', className)}
      >
        {children}
      </TextButton>
      <Icon
        name="arrowRightIcon"
        className="transition-transform duration-300 ease-in-out group-hover:translate-x-1 text-primary"
      />
    </div>
  );
}
